import { setTerms } from './helpers';

export const setLandStatusTypes = setTerms('land_status');
